import * as React from "react";

const SoundPlayer = (props: any) => (
    <svg
        width={64}
        height={64}
        viewBox="0 0 64 64"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 0h64v64H0z" fillOpacity="0"/>
            <g stroke="#7B838C" strokeWidth="4">
                <path d="M12.5 28.5c0-12.5 10.75-18 19.5-18s19.5 5.5 19.5 18" strokeLinecap="square"/>
                <path d="M9 34v12h4V34H9zM51 34v12h4V34h-4z"/>
            </g>
            <path d="M32 53c-7.178 0-13-5.819-13-13.002C19 32.818 24.822 27 32 27c7.182 0 13 5.819 13 12.998C45 47.181 39.182 53 32 53z" fill="#D2D5D8"/>
            <path fill="#7B838C" d="M29 34.1l9.9 5.9-9.9 5.9z"/>
        </g>
    </svg>
);

export default SoundPlayer;

